import React, { useEffect, useRef } from "react";
import { Navigate, Outlet, useLocation, useSearchParams } from "react-router-dom";
import { DemoBanner } from "@components/demo";
import { PATHS } from "@constants/Paths";
import { mustAcceptTerms } from "@piiqtechnologies/ui-lib";
import { useAuthContext } from "@stores/AuthContext";
import { getUserContext } from "@stores/utils";
export const AuthLayout = () => {
    var _a;
    const { onLogin, user, isDemoUser, isFreeTrial } = useAuthContext();
    const [searchParams, setSearchParams] = useSearchParams();
    const location = useLocation();
    const tokenFromSearch = searchParams.get("token");
    const isAuthenticating = useRef(false);
    const isOverviewRoute = location.pathname.startsWith("/overview");
    // Check sessionStorage directly as a fallback for isFreeTrial,
    // because setFreeTrial() writes to sessionStorage synchronously
    // but the React context state update may not have propagated yet
    const isFreeTrialResolved = isFreeTrial || Boolean((_a = getUserContext()) === null || _a === void 0 ? void 0 : _a.isFreeTrial);
    useEffect(() => {
        if (!tokenFromSearch)
            return;
        isAuthenticating.current = true;
        onLogin({ token: tokenFromSearch }, true, { skipRedirect: isOverviewRoute });
        setSearchParams((prev) => {
            prev.delete("token");
            return prev;
        }, { replace: true });
    }, [onLogin, tokenFromSearch, isOverviewRoute, setSearchParams]);
    if ((tokenFromSearch || isAuthenticating.current) && !user) {
        return null;
    }
    if (!user && !(isFreeTrialResolved && isOverviewRoute)) {
        return React.createElement(Navigate, { to: PATHS.LOGIN, replace: true, state: { redirectTo: location } });
    }
    if (user && !isDemoUser && mustAcceptTerms(user)) {
        return React.createElement(Navigate, { to: PATHS.TERMS_CONDITIONS_AGREEMENT, replace: true, state: { redirectTo: location } });
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(DemoBanner, null),
        React.createElement(Outlet, null)));
};
export default AuthLayout;
